import React from 'react';

import HeaderUno from '../Compartidos/HeaderUno';
import HeaderMetodos from '../../AuxiliaresPaginas/HeaderMetodos';

// css
import {
    Container,
    BtnColores
} from '../../Css/MetodosCSS/StyledMethods';

import {
    HrMetodos
} from '../../Css/StyledHeader';


const ConcienciaFonologica = () => {

    return (

        <div
            style={{
                width: '100%',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                boxSizing: 'border-box',
                backgroundColor: '#FFFFFF'
            }}
        >


            {/* ================================================= */}
            {/* HEADER                                            */}
            {/* ================================================= */}

            <div
                style={{
                    flexShrink: 0
                }}
            >

                <HeaderUno />


                <HrMetodos
                    margin='0 0.2rem 0.5rem 0.2rem'
                />


                <HeaderMetodos

                    l1={"metodos/"}

                    l2={"lenguaje/"}

                    n1={"Métodos"}

                    n2={"LENGUAJE"}

                    componente={
                        "CONCIENCIA FONOLÓGICA"
                    }

                    paciente={true}

                    bgcolor="#FF9B2A"

                    color="white"

                    width='96vw'

                    shadow="0px 4px 4px rgba(0, 0, 0, 0.25)"

                    display="none"

                />

            </div>


            {/* ================================================= */}
            {/* ESPACIO BLANCO                                    */}
            {/* ================================================= */}

            <div
                style={{
                    height: '16px',
                    flexShrink: 0,
                    backgroundColor: '#FFFFFF'
                }}
            />


            {/* ================================================= */}
            {/* FONDO LENGUAJE                                    */}
            {/* ================================================= */}

            <div
                style={{
                    width: '100%',

                    flex: 1,

                    minHeight: 0,

                    boxSizing: 'border-box',

                    backgroundImage:
                        "url('/img/portadas/lenguaje_caratula_principal.jpg')",

                    backgroundSize: 'cover',

                    backgroundPosition: 'center',

                    backgroundRepeat: 'no-repeat',

                    display: 'flex',

                    justifyContent: 'center',

                    alignItems: 'center',

                    overflow: 'hidden'
                }}
            >


                <Container

                    align="space-around"

                    justify="center"

                    height="100%"

                    width="100%"

                    direction="column"

                >


                    {/* ========================================= */}
                    {/* PRIMERA FILA                              */}
                    {/* ========================================= */}

                    <Container
                        justify="center"
                        style={{
                            gap: 'clamp(1.5rem, 4vw, 4rem)',
                            flexWrap: 'wrap'
                        }}
                    >


                        <BtnColores
                            bgcolor="#FFFFFF"
                            style={{
                                backgroundColor: '#FFFFFF',
                                color: '#000000'
                            }}
                            to={
                                '/escritorio/metodos/lenguaje/conciencia-fonologica/cc-rima-lexica'
                            }
                        >
                            CC Rima Léxica
                        </BtnColores>


                        <BtnColores
                            bgcolor="#FFFFFF"
                            style={{
                                backgroundColor: '#FFFFFF',
                                color: '#000000'
                            }}
                            to={
                                '/escritorio/metodos/lenguaje/conciencia-fonologica/cc-silabica'
                            }
                        >
                            CC Silábica
                        </BtnColores>


                        <BtnColores
                            bgcolor="#FFFFFF"
                            style={{
                                backgroundColor: '#FFFFFF',
                                color: '#000000'
                            }}
                            to={
                                '/escritorio/metodos/lenguaje/conciencia-fonologica/cc-lexica'
                            }
                        >
                            CC Léxica
                        </BtnColores>


                    </Container>


                    {/* ========================================= */}
                    {/* SEGUNDA FILA                              */}
                    {/* ========================================= */}

                    <Container
                        justify="center"
                        margin="28px 0px 0px 0px"
                        style={{
                            gap: 'clamp(2rem, 7vw, 7rem)',
                            flexWrap: 'wrap'
                        }}
                    >


                        <BtnColores
                            font="22px"
                            bgcolor="#FFFFFF"
                            style={{
                                backgroundColor: '#FFFFFF',
                                color: '#000000'
                            }}
                            to={
                                '/escritorio/metodos/lenguaje/conciencia-fonologica/cc-intrasilabica'
                            }
                        >
                            CC Intrasilábica
                        </BtnColores>


                        <BtnColores
                            bgcolor="#FFFFFF"
                            style={{
                                backgroundColor: '#FFFFFF',
                                color: '#000000'
                            }}
                            to={
                                '/escritorio/metodos/lenguaje/conciencia-fonologica/cc-fonemica'
                            }
                        >
                            CC Fonémica
                        </BtnColores>


                    </Container>


                </Container>


            </div>


        </div>
    );
};


export default ConcienciaFonologica;